import omit from 'lodash/omit';
import { Dispatch } from 'redux';
import { clearFields } from 'redux-form';
import {
    FormData,
    isInventoryQuestion,
    SurveyQuestion,
} from '../../models/survey';

const hasRequiredChildOrParentOrSibling = ({
    questions,
    currentQuestionName,
    currentQuestionParentName,
}: {
    questions: any[];
    currentQuestionName: string;
    currentQuestionParentName: string | undefined;
}) =>
    questions.some(
        (question) =>
            (question.name === currentQuestionParentName ||
                question.renderConditionTrigger?.parentQuestionId ===
                    currentQuestionName ||
                (currentQuestionParentName
                    ? question.renderConditionTrigger?.parentQuestionId ===
                      currentQuestionParentName
                    : false)) &&
            question.required,
    );

export const isRequiredQuestion = (
    question: SurveyQuestion,
    questions: SurveyQuestion[],
) =>
    question.required ||
    isInventoryQuestion(question.choices) ||
    hasRequiredChildOrParentOrSibling({
        questions,
        currentQuestionName: question.name,
        currentQuestionParentName:
            question.renderConditionTrigger?.parentQuestionId,
    });

export const clearSurveyField =
    (formName: string, field: string) => (dispatch: Dispatch<any>) =>
        dispatch(clearFields(formName, true, true, field));

export const isAttendeeField = (field: string): boolean =>
    field.startsWith('A-');

export const removeCopyBillingInfoField = (formData: FormData) =>
    Object.keys(formData).reduce((otherFields, fieldName: string) => {
        const cleanedFormAnswer = isAttendeeField(fieldName)
            ? omit(formData[fieldName], 'copyBillingInfo')
            : formData[fieldName];

        return {
            ...otherFields,
            [fieldName]: cleanedFormAnswer,
        };
    }, {});
